import React, { useState, useEffect } from 'react';
import { Grid, Link } from '@material-ui/core';
import { AutoPaysVService } from '../../../services/V2/gozer';
import { AutoPaysVService as AutopaymentService } from '../../../services/V3/charon';
import { formatMoney, handleError, handleErrorToast } from '../../shared/Functions';
import { DistrictsVService } from '../../../services/V2/padre';
import { getAutoPaymentBatch } from '../../shared/ExportFunctions';
import CancelIcon from '@material-ui/icons/Cancel';
import '../../../scss/UVP.scss';
import { authProvider } from '../../../services/Security';
import { CustomTable } from '../../shared/CustomTable';
import { ConfirmModal } from '../../shared/ConfirmModal';

export const UVPAutoPaymentBatch = ({errorToast, successToast, selectedPayment, setSelectedTab, setHasBeenCanceled, setHasBeenCanceledByUser, refresh, setRefresh, setLoading,
    setRunningBatch
}) => {
    const [payments, setPayments] = useState<any>();
    const [district, setDistrict] = useState<any>();
    const [fullBatch, setFullBatch] = useState<any[]>([]);
    const [batch, setBatch] = useState<any[]>([]);
    const [disablePayments, setDisablePayments] = useState<boolean>(false);
    const [showCancelBatch, setShowCancelBatch] = useState<boolean>(false);
    const [showCancelPayment, setShowCancelPayment] = useState<any | null>(null);
    const [showCancelLastPayment, setShowCancelLastPayment] = useState<any | null>(null);
    const [showRunBatch, setShowRunBatch] = useState<boolean>(false);

    useEffect(() => {
        if(!refresh)
            setRefresh(true)
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        AutoPaysVService.autoPaysVGetById(selectedPayment.id)
            .then((x: any) => {
                var username = authProvider.getUser().Username
                if(x.canceled && (x.modifiedByUser.toLowerCase().includes("rocketpack"))) {
                    setHasBeenCanceled(true)
                } else if(x.canceled && !x.modifiedByUser.toLowerCase().includes(username.toLowerCase())) {
                    setHasBeenCanceledByUser(x.modifiedByUser)
                }
                setPayments(x)
                setFullBatch(x.autopayBatch)
                setDisablePayments(x.hasBeenRun)
                DistrictsVService.districtsVGetById(x?.districtId)
                    .then((x) => {
                        setDistrict(x)
                    }).catch(x => {
                        errorToast(handleErrorToast(x))
                    })
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
    }, [selectedPayment])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = () => {
        setLoading(true)
        getAutoPaymentBatch(selectedPayment.id, (new Date()).toLocaleString())
            .then(x => {setLoading(false)})
            .catch(err => {
                handleError(err)
                setLoading(false)
            })
    }

    const removeFromAutoPay = () => {
        setShowCancelPayment(null)
        let list = Array.from(batch);
        let index = list.findIndex(x => x.billingAccount.id === showCancelPayment.billingAccount.id)
        list[index].processPayment = false;
        setBatch(list)

        setLoading(true)
        AutoPaysVService.autoPaysVUpdateBatch(selectedPayment.id, list)
            .then((x:any) => {
                successToast("Removed")
                AutoPaysVService.autoPaysVGetById(selectedPayment.id)
                    .then((x: any) => {
                        setPayments(x)
                        setFullBatch(x.autopayBatch)
                        setLoading(false)
                    }).catch(x => {
                        errorToast(handleErrorToast(x))
                        setLoading(false)
                    })
            })
            .catch(err => {
                handleError(err)
                setLoading(false)
            })
    }

    const handleRun = () => {
        setShowRunBatch(false)
        setDisablePayments(true)
        setLoading(true)
        AutopaymentService.autoPaysVPostAutoPay(payments.id)
            .then(x => {
                successToast(`Running. You can leave this page and come back later or refresh this page for results.`);
                setDisablePayments(true);
                setSelectedTab(0)
                setLoading(false)
                setRunningBatch(true)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }

    const cancelBatch = async () =>{
        setShowCancelBatch(false)
        setLoading(true)
        await AutoPaysVService.autoPaysVCancelBatch(selectedPayment.id);
        successToast("Batch canceled.")
        setLoading(false)
        setSelectedTab(0)
    }

    const checkLastPayment = (rowData) =>{
        let list = Array.from(fullBatch);
        let filteredList = list.filter(x => x.billingAccountId !== rowData.billingAccount.id)

        if(Object.values(filteredList).every(x => !x.processPayment)) {
            setShowCancelLastPayment(rowData)
        }

        else {
            setShowCancelPayment(rowData)
        }

    }

    if(!payments) return null;

    return (
        <React.Fragment>
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelBatch(false)}
                show={showCancelBatch}
                confirmCallback={() => cancelBatch()}
                title={"Cancel Batch"}
                description={`Are you sure you want to cancel Batch ${payments?.batchId}?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowRunBatch(false)}
                show={showRunBatch}
                confirmCallback={() => handleRun()}
                title={"Run Batch"}
                description={`Are you sure you want to run Recurring Payments for ${district?.name}?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelPayment(null)}
                show={showCancelPayment}
                confirmCallback={() => removeFromAutoPay()}
                title={"Cancel Payment"}
                description={`Are you sure you want to cancel this payment?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelLastPayment(null)}
                show={showCancelLastPayment}
                confirmCallback={() => cancelBatch()}
                title={"Cancel Batch"}
                description={`This is the last payment in the batch.  Cancelling this payment will cancel the batch.  Are you sure you want to cancel this payment?`} />
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <Grid container style={{ fontSize: "14px", padding: "0px", margin: "0px 0px 0px 0px" }}>
                    <Grid item xs={1}>
                        <b>Batch ID: </b>{payments?.batchId}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Run Date: </b>N/A
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Count: </b>{payments?.batchCount}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Value: </b>{formatMoney(payments?.batchAmount)}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Download: </b><Link onClick={handleDownload} className="clickable">csv</Link>
                    </Grid>
                </Grid>
                <CustomTable
                    columns={[
                        { title: 'Account', field: '', render: (rowData) => rowData?.billingAccount?.accountNumber },
                        { title: 'Name', field: '', render: (rowData) => rowData?.billingAccount?.customer?.fullName },
                        { title: 'Service Address', field: '', render: (rowData) => rowData?.billingAccount?.services[0]?.serviceAddress?.street },
                        { title: 'Payment Amount', field: '', render: rowData => formatMoney(rowData?.paymentAmount) },
                        { title: 'Service Fee', field: '', render: rowData => formatMoney(rowData?.feeAmount) },
                        { title: 'Payment Method', field: '', render: rowData => rowData?.token?.cardType ?? rowData?.token?.achType },
                        { title: 'Last 4', field: '', render: rowData => rowData?.token?.last4 },
                        { title: 'Payment Status', field: '', render: rowData => rowData?.processPayment ? "Pending" : "Canceled" },
                    ]}
                    pageSize={15}
                    enablePaging={false}
                    actions={[
                        {
                            icon: () => <CancelIcon htmlColor={"red"} />,
                            tooltip: "Remove From Batch",
                            onClick: (rowData: any, index: any) => {
                                checkLastPayment(rowData);
                            },
                            disabled: (rowData) => !rowData?.processPayment
                        }
                    ]}
                    dataEndpoint={(query) => {
                        return new Promise((resolve, reject) => {
                            AutoPaysVService.autoPaysVGetBatch(payments.id, {
                                pageNumber: query.pageNumber,
                                numberPerPage: 15,
                                orderBy: 'id',
                                orderByDesc: true,
                                searchQuery: query.searchQuery ?? "",
                                filters: [] 
                            })
                            .then((x:any) => {
                                setBatch(x.items)
                                resolve({
                                    items: x.items,
                                    numberOfItems: x.numberOfItems
                                })
                            })
                            .catch(x => reject(x))
                        })
                    }}
                    dataSet={null}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    title={""}
                    districtId={payments?.districtId}
                    addedQuery={null}
                    hiddenColumns={[]}
                    setHiddenColumns={null}
                    hiddenColumnsDisabled={true}
                    tableHeight={"400px"}
                    enableSearch={true} 
                    searchPlaceholder={"Account Number"}
                    />

                {!payments.canceled &&
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "3px" }}>
                        <button disabled={payments.canceled} onClick={() => setShowCancelBatch(true)} className='uvp-button gray-button'>Cancel Batch</button>
                        <button disabled={disablePayments || payments.canceled} onClick={() => setShowRunBatch(true)} className='uvp-button green-button'>Submit Batch</button>
                    </div>
                }
            </Grid>
        </React.Fragment>
    );
}